import { AuthRoleIdEnum } from 'constants/user'

// Mirror of the backend EMembershipStatus values (org-membership status).
export enum EMembershipStatus {
  PENDING = 'pending',
  ACTIVE = 'active',
  INACTIVE = 'inactive',
  REMOVED = 'removed'
}

export type MembershipBadge = 'owned' | 'invited' | 'invite-pending'

// Resolve the Teams-list badge for a membership row:
// - a pending invitation the user hasn't accepted → Invite Pending
// - the OWNER role                                → Owned
// - any other active membership                  → Invited (joined via invite)
export function getMembershipBadge(input: { roleId?: AuthRoleIdEnum; status?: EMembershipStatus }): MembershipBadge {
  if (input.status === EMembershipStatus.PENDING) return 'invite-pending'
  if (input.roleId === AuthRoleIdEnum.OWNER) return 'owned'
  return 'invited'
}

export const MEMBERSHIP_BADGE_LABEL: Record<MembershipBadge, string> = {
  owned: 'Owned',
  invited: 'Invited',
  'invite-pending': 'Invite Pending'
}
